import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Support from './views/Support.vue'
import Requests from './views/Requests.vue'
import Reports from './views/Reports.vue'
import ReportsCreate from './views/ReportsCreate.vue'
import ReportsShow from './views/ReportsShow.vue'
import ReportsEdit from './views/ReportsEdit.vue'
import RequestsCreate from './views/RequestsCreate.vue'
import RequestsShow from './views/RequestsShow.vue'
import AnnualLeaveRequests from './views/AnnualLeaveRequests.vue'
import AnnualLeaveRequestsShow from './views/AnnualLeaveRequestsShow.vue'
import AnnualLeaveRequestsCreateEdit from './views/AnnualLeaveRequestsCreateEdit.vue'
import Handbook from './views/Handbook.vue'
import Newsletter from './views/Newsletter.vue'
import Account from './views/Account.vue'
import Profile from './views/Profile.vue'
import ProfilePersonal from './views/ProfilePersonal.vue'
import ProfileContact from './views/ProfileContact.vue'
import ProfileEmergencyContacts from './views/ProfileEmergencyContacts.vue'
import ProfileBank from './views/ProfileBank.vue'
import ProfilePension from './views/ProfilePension.vue'
import ProfileWorkDetails from './views/ProfileWorkDetails.vue'
import ProfileHealthInsurance from './views/ProfileHealthInsurance.vue'
import PayRoll from './views/PayRoll.vue'
import PaySlips from './views/PaySlips.vue'
import Documents from './views/Documents.vue'
import DocumentsShow from './views/DocumentsShow.vue'
import DocumentsEdit from './views/DocumentsEdit.vue'
import Notification from './views/Notifications.vue'
import Insurances from './views/insurances/Insurances.vue'
import Login from './views/Login.vue'
import LoginIssue from './views/LoginIssue.vue'
import Password from './views/Password.vue'
import PasswordReset from './views/PasswordReset.vue'
import auth from './auth'
import store from './store'
import Expenses from "./views/Expenses";
import ExpensesCreate from "./views/ExpensesCreate";
import ExpensesShow from "./views/ExpensesShow";
import ExpensesEdit from "./views/ExpensesEdit";
import Timesheets from "./views/Timesheets";
import TimesheetsAdd from "./views/TimesheetsAdd";
import TimesheetsShow from "./views/TimesheetsShow";
import Leaves from "./views/Leaves";
import LeavesCreate from "./views/LeavesCreate";
import LeavesShow from "./views/LeavesShow";
import LeavesEdit from "./views/LeavesEdit";
import PageNotFound from "./views/PageNotFound";
import Employees from "./views/Employees";

Vue.use(Router)

let requireAuth = (to, from, next) => {

    if (!!to.query.token) {
        auth.loginWithToken(to.query.token, (loggedIn) => {
            if (loggedIn) {
                store.commit('clearErrors');
                store.dispatch('fetchEmployee');
                store.dispatch('fetchEmployeeExtended');
                next('/');
            }
        })
    }

    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        })
    } else {
        next()
    }
}

let onlyGuests = (to, from, next) => {
    store.commit('clearErrors');
    if (auth.loggedIn()) {
        if (to.name === 'password') {
            next('/account')
        } else {
            next('/')
        }
    } else {
        next()
    }
}

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            beforeEnter: requireAuth
        },

        {
            path: '/support/:type?',
            name: 'support',
            component: Support,
            beforeEnter: requireAuth,
        },

        {
            path: '/requests',
            name: 'requests',
            component: Requests,
            beforeEnter: requireAuth,
        },

        {
            path: '/requests/list',
            name: 'requests-list',
            component: Requests,
            beforeEnter: requireAuth,
        },

        {
            path: '/requests/create/:type?',
            name: 'requests-create',
            component: RequestsCreate,
            beforeEnter: requireAuth
        },

        {
            path: '/requests/:request',
            name: 'requests-show',
            component: RequestsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/annual-leave',
            name: 'annual-leave-show',
            component: AnnualLeaveRequests,
            beforeEnter: requireAuth
        },

        {
            path: '/annual-leave/:annual_leave/',
            name: 'annual-leave-request-create',
            component: AnnualLeaveRequestsCreateEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/annual-leave/:annual_leave/:request',
            name: 'annual-leave-requests-show',
            component: AnnualLeaveRequestsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/annual-leave/:annual_leave/:request/edit',
            name: 'annual-leave-request-edit',
            component: AnnualLeaveRequestsCreateEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/reports/list',
            name: 'reports-list',
            component: Reports,
            beforeEnter: requireAuth,
        },

        {
            path: '/expenses',
            name: 'expenses',
            component: Expenses,
            beforeEnter: requireAuth,
        },

        {
            path: '/expenses/create',
            name: 'expenses-create',
            component: ExpensesCreate,
            beforeEnter: requireAuth
        },

        {
            path: '/expenses/:expense',
            name: 'expenses-show',
            component: ExpensesShow,
            beforeEnter: requireAuth
        },

        {
            path: '/expenses/:expense/edit',
            name: 'expenses-edit',
            component: ExpensesEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/timesheets',
            name: 'timesheets',
            component: Timesheets,
            beforeEnter: requireAuth,
        },

        {
            path: '/timesheets/:date/add',
            name: 'timesheets-add',
            component: TimesheetsAdd,
            beforeEnter: requireAuth
        },

        {
            path: '/timesheets/:entry',
            name: 'timesheets-show',
            component: TimesheetsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/leaves',
            name: 'leaves',
            component: Leaves,
            beforeEnter: requireAuth,
        },

        {
            path: '/leaves/create',
            name: 'leaves-create',
            component: LeavesCreate,
            beforeEnter: requireAuth
        },

        {
            path: '/leaves/:leave',
            name: 'leaves-show',
            component: LeavesShow,
            beforeEnter: requireAuth
        },

        {
            path: '/leaves/:leave/edit',
            name: 'leaves-edit',
            component: LeavesEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            beforeEnter: requireAuth,
        },

        {
            path: '/reports/create/:type?',
            name: 'reports-create',
            component: ReportsCreate,
            beforeEnter: requireAuth
        },

        {
            path: '/reports/:report/edit/:step?',
            name: 'reports-edit',
            component: ReportsEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/reports/:report',
            name: 'reports-show',
            component: ReportsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/handbooks',
            name: 'handbooks',
            component: Handbook,
            beforeEnter: requireAuth,
        },

        {
            path: '/newsletters',
            name: 'newsletters',
            component: Newsletter,
            beforeEnter: requireAuth,
        },

        {
            path: '/account',
            name: 'account',
            component: Account,
            beforeEnter: requireAuth
        },

        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            beforeEnter: requireAuth,
            meta: {transitionName: 'zoom'},
        },

        {
            path: '/profile/personal',
            name: 'profile-personal',
            component: ProfilePersonal,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/contact',
            name: 'profile-contact',
            component: ProfileContact,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/emergency-contacts',
            name: 'profile-emergency-contacts',
            component: ProfileEmergencyContacts,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/bank',
            name: 'profile-bank',
            component: ProfileBank,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/pension',
            name: 'profile-pension',
            component: ProfilePension,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/work-details',
            name: 'profile-work-details',
            component: ProfileWorkDetails,
            beforeEnter: requireAuth,
        },

        {
            path: '/profile/health-insurance',
            name: 'profile-health-insurance',
            component: ProfileHealthInsurance,
            beforeEnter: requireAuth,
        },

        {
            path: '/documents',
            name: 'documents',
            component: Documents,
            beforeEnter: requireAuth
        },

        {
            path: '/documents/mandatory/:type/edit',
            name: 'documents-mandatory-edit',
            component: DocumentsEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/documents/mandatory/:type',
            name: 'documents-mandatory-show',
            component: DocumentsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/documents/:document/edit',
            name: 'documents-edit',
            component: DocumentsEdit,
            beforeEnter: requireAuth
        },

        {
            path: '/documents/:document',
            name: 'documents-show',
            component: DocumentsShow,
            beforeEnter: requireAuth
        },

        {
            path: '/notifications',
            name: 'notifications',
            component: Notification,
            beforeEnter: requireAuth
        },

        {
            path: '/insurances',
            name: 'insurances',
            component: Insurances,
            beforeEnter: requireAuth
        },


        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: onlyGuests
        },

        {
            path: '/login/issue',
            name: 'login-issue',
            component: LoginIssue,
            beforeEnter: onlyGuests,
        },

        {
            path: '/password/reset',
            name: 'password-reset',
            component: PasswordReset,
            beforeEnter: onlyGuests,
        },

        {
            path: '/password/:token',
            name: 'password',
            component: Password,
            beforeEnter: onlyGuests
        },

        {
            path: '/logout',
            name: 'logout',
            beforeEnter(to, from, next) {
                auth.logout()
                window.location.reload()
            }
        },

        {
            path: '/pay-roll',
            name: 'pay-roll',
            component: PayRoll,
            beforeEnter: requireAuth,
        },

        {
            path: '/pay-roll/pay-slips',
            name: 'pay-roll-pay-slips',
            component: PaySlips,
            beforeEnter: requireAuth,
        },

        {
            path: '/pay-roll/cloudpay',
            beforeEnter(to, from, next) {
                window.open('https://self-service.cloudpay.net/app/employee/Login.jsp', '_blank');
                next('/');
            }
        },

        {
            path: '/employees',
            name: 'employees',
            component: Employees,
            beforeEnter: requireAuth,
        },

        {
            path: '/404',
            name: 'not-found',
            component: PageNotFound
        },

        {
            path: '*',
            redirect: {name: 'not-found'}
        },
    ]
})

router.beforeEach((to, from, next) => {
    // hack to allow for forward slashes in path ids
    if (to.fullPath.includes('//')) {
        next(to.fullPath.replace('//', '/'));
    }
    next();
});

export default router;
